module.exports = __webpack_public_path__ + "826a1583e1f470c64a71008843ee60b4.svg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/logos/ppu.svg
 ** module id = 436
 ** module chunks = 0
 **/